import { Navigate } from "react-router-dom";
import { isTokenExpired } from "../utils/jwtUtils";
import { getToken } from "../utils/auth";

export default function RequireAuth({ children }) {
  let token = null;

  try {
    token = getToken();
  } catch (e) {
    console.error("getToken hatası:", e);
    return <Navigate to="/login" replace />;
  }

  try {
    if (!token || isTokenExpired(token)) {
      try {
        localStorage.clear();
        sessionStorage.clear();
      } catch (e) {
        console.error("Storage temizleme hatası:", e);
      }

      return <Navigate to="/login" replace />;
    }
  } catch (e) {
    console.error("Token kontrol hatası:", e);
    return <Navigate to="/login" replace />;
  }

  return children;
}